import { combineReducers } from 'redux';

import interventions from './interventions';
import isBillingLoading from './isBillingLoading';
import isBookingDropOffModalVisible from './isBookingDropOffModalVisible';
import isBookingPickUpModalVisible from './isBookingPickUpModalVisible';
import isClientDocumentsLoading from './isClientDocumentsLoading';
import isDeleting from './isDeleting';
import isLoadingShareLink from './isLoadingShareLink';
import isReady from './isReady';
import isRentalVehicleLoading from './isRentalVehicleLoading';
import isSending from './isSending';
import isUpdatingStatus from './isUpdatingStatus';
import selectedId from './selectedId';

export default combineReducers({
  isReady,
  isSending,
  isDeleting,
  selectedId,
  interventions,
  isBillingLoading,
  isUpdatingStatus,
  isLoadingShareLink,
  isRentalVehicleLoading,
  isClientDocumentsLoading,
  isBookingPickUpModalVisible,
  isBookingDropOffModalVisible,
});
